
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_499_4578)","fill":"#010101"}},[_c('path',{attrs:{"d":"M22.043 14.628c0 1.924-1.217 3.7-3.027 4.403a4.87 4.87 0 01-5.293-1.217c-2.214-2.406-1.275-6.393 1.785-7.59 3.088-1.204 6.54 1.124 6.54 4.404h-.005zm-3.23 1.168c.4.2.718-.412.318-.617l-1.262-.633a.587.587 0 00-.254-.412v-2.161c0-.445-.698-.445-.698 0v2.16c-.613.422-.017 1.377.637 1.03l1.258.637v-.004zM2.23 15.728l1.86-1.859a.71.71 0 10-1.006-1.004l-1.858 1.858a.71.71 0 101.005 1.005zM7.452 14.548a.71.71 0 00-1.005 0l-4.713 4.714a.71.71 0 101.005 1.005l4.713-4.714a.71.71 0 000-1.005z"}}),_c('path',{attrs:{"d":"M12.958 18.49c-2.688-2.924-1.548-7.76 2.165-9.21a5.725 5.725 0 014.117-.017L21.965.931a.71.71 0 00-.895-.895L.491 6.759a.708.708 0 00-.134 1.287l7.777 4.522a.705.705 0 00.78-.045l2.185-1.626-1.625 2.185a.713.713 0 00-.045.78l4.521 7.778a.709.709 0 001.287-.135l.445-1.368a5.839 5.839 0 01-2.728-1.65l.004.004zM8.13 17.911L6.27 19.77a.71.71 0 101.006 1.005l1.858-1.859a.71.71 0 10-1.005-1.005z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_499_4578"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.002)","d":"M0 0h22.041v22H0z"}})])])])
          )
        }
      }
    